import React, { useMemo } from 'react'
import { MilkProductionField } from '../style'
import { useFormContext, useWatch } from 'react-hook-form'
import { Form } from 'semantic-ui-react'
import WarningIcon from '~/pages/Farmer/ClimateCheck/AnswerClimateCheck/Steps/WarningIcon'
import ErrorIcon from '~/pages/Farmer/ClimateCheck/AnswerClimateCheck/Steps/ErrorIcon'

const EnergyPerCattle: React.FC = () => {
  const { control, formState: { isSubmitted, errors }, clearErrors, setError } = useFormContext()

  const watchEnergyUse = useWatch({ control, name: 'youngCattleEnergyUse' })
  const watchCattleNumber = useWatch({ control, name: 'youngCattleNumber' })

  const energyConsumptionPerCow = useMemo(() => {

    if (watchEnergyUse && watchCattleNumber) {
      const energyConsumption = Math.floor(watchEnergyUse / watchCattleNumber)
      if (energyConsumption < 5 || energyConsumption > 600) {
        setError('energyCattleConsumption', { message: 'Der Stromverbrauch pro Färse und Jahr muss mind. 5 kWh und darf max. 500 kWh betragen.' })
      } else {
        clearErrors('energyCattleConsumption')
      }

      return energyConsumption
    }

    return 0
  }, [watchCattleNumber, watchEnergyUse])

  return <Form.Field>
    <MilkProductionField>
      <label style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        <div>{'kWh pro Färse u. Jahr'}</div>
        {(energyConsumptionPerCow < 10 || energyConsumptionPerCow > 250) && <WarningIcon
          control={control}
          name='energyCattleConsumption'
          content={'Der Stromverbrauch pro Färse und Jahr liegt außerhalb der normalen Bereiche von mind. 10 kWh und max. 250 kWh.'}
        />}
        <ErrorIcon
          control={control}
          name={'energyCattleConsumption'}
        />
      </label>
      <div>{`${energyConsumptionPerCow} kWh pro Färse u. Jahr`}</div>
    </MilkProductionField>
  </Form.Field>
}
export default EnergyPerCattle